module.exports = __webpack_public_path__ + "static/img/construct1.fa4523f1.png";